module.exports = __webpack_public_path__ + "img/3.5f4e0f1f.jpg";